import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from '@material-ui/core'
import { traerMovimientos } from "../../actions/movimientos/movimientos";
import TableGeneric from "../compartidos/abms/TableGeneric";
import moment from "moment";
import "moment/locale/es";

export const GrillaMovimientos = () => {
  const { items } = useSelector((state) => state.movimientos);
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(traerMovimientos())
    // eslint-disable-next-line
  }, [])

  return (
    <>
      { items.length > 0 &&
        <Card>
          <TableGeneric
            data={items}
            columns={[
              {
                label: "Campo",
                id: "campo",
                sort: true
              },
              {
                label: "Valor Anterior",
                id: "valorAnterior",
                customBody: (item) => <div style={{ whiteSpace: "pre-line" }}>{item.valorAnterior}</div>,
              },
              {
                label: "Valor Nuevo",
                id: "valorNuevo",
                customBody: (item) => <div style={{ whiteSpace: "pre-line" }}>{item.valorNuevo}</div>,
              },
              {
                label: "Fecha",
                id: "fecha",
                customBody: (item) => moment(item.fecha).isValid() ? moment(item.fecha).format('DD/MM/YYYY HH:mm') : '',
                sort: true
              },
              {
                label: "Usuario",
                id: "usuario.userName",
                sort: true
              },
              {
                label: "Seccional",
                id: "usuario.seccional.descripcion_seccional",
                sort: true
              }
              
            ]}
          />
        </Card>
      }
    </>
  );
};
